<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-consulta">Trámites</router-link> >
            <router-link :to="'/planillas-observaciones/' + planillaSeleccionada.idTramite">
            Trámite {{ planillaSeleccionada.idTramite }}: Atenciones con observaciones
            </router-link>
            > Número de atención: {{ planillaSeleccionada.numero }}
          </div>
        </div>
<!--		
        <div class="col-1">
          <span class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true">
            help
          </span>
        </div>
-->
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>

    <hr />

    <!-- Info planilla -->
    <div class="card mb-4 border-primary">
      <div class="card-header bg-primary text-white py-2">
        <span class="material-symbols-outlined" style="vertical-align: middle; font-size: 20px;">
          person
        </span>
        <strong class="ms-1">Datos de la atención</strong>
      </div>
      <div class="card-body py-2">
        <div class="row g-2 small">
          <div class="col-auto">
            <span class="fw-bold text-muted">Número:</span>
            <span class="ms-1 badge bg-secondary">{{ planillaSeleccionada.numero }}</span>
          </div>
          <div class="col-auto">
            <span class="fw-bold text-muted">Cédula:</span>
            <span class="ms-1">{{ planillaSeleccionada.cedula }}</span>
          </div>
          <div class="col-auto">
            <span class="fw-bold text-muted">Nombre:</span>
            <span class="ms-1">{{ planillaSeleccionada.nombre }}</span>
          </div>
          <div class="col-auto">
            <span class="fw-bold text-muted">Fecha desde:</span>
            <span class="ms-1">{{ getFormattedDate(planillaSeleccionada.fechaDesde) }}</span>
          </div>
          <div class="col-auto">
            <span class="fw-bold text-muted">Fecha hasta:</span>
            <span class="ms-1">{{ getFormattedDate(planillaSeleccionada.fechaHasta) }}</span>
          </div>
          <div class="col-auto">
            <span class="fw-bold text-muted">Hora desde:</span>
            <span class="ms-1">{{ planillaSeleccionada.horaDesde }}</span>
          </div>
          <div class="col-auto">
            <span class="fw-bold text-muted">Hora hasta:</span>
            <span class="ms-1">{{ planillaSeleccionada.horaHasta }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulario observación -->
    <div class="card shadow-sm border border-primary" style="background-color: #f1f3f5;">
      <div class="card-body">
        <form>

          <!-- Código prestador -->
<!--
          <div class="mb-3">
            <label class="form-label fw-bold text-muted small">
              Código del prestador de salud
            </label>
            <p class="form-control-plaintext border-bottom pb-1">
              {{ datoPlaDetObs.planillaDetCodigo }} - {{ datoPlaDetObs.planillaDetDescripcion }}
            </p>
          </div>
-->
          <!-- Código estándar -->
          <div class="mb-3">
            <label class="form-label fw-bold text-muted small">
              Descripción
            </label>
<!--
            <p class="form-control-plaintext border-bottom pb-1">
              {{ datoPlaDetObs.elementoCodigo }} - {{ datoPlaDetObs.elementoNombre }}
            </p>
-->
            <p class="form-control-plaintext border-bottom pb-1">
              {{ datoPlaDetObs.elementoNombre }}
            </p>
          </div>

          <!-- Observación estándar -->
          <div class="mb-3">
            <label class="form-label fw-bold text-muted small">
              Observación estándar
            </label>
            <p class="form-control-plaintext border-bottom pb-1">
              {{ datoPlaDetObs.observacionDescripcion }}
            </p>
          </div>

          <!-- Descripción complementaria -->
          <div class="mb-3">
            <label class="form-label fw-bold text-muted small">
              Observación complementaria
            </label>
            <p class="form-control-plaintext border-bottom pb-1"
              style="text-transform: uppercase; white-space: pre-wrap;">
              {{ datoPlaDetObs.descripcion }}
            </p>
          </div>

          <!-- Respuesta estándar -->
          <div class="mb-3">
            <label for="idRespuesta" class="form-label fw-bold">
              Respuesta estándar
            </label>
            <select class="form-select" id="idRespuesta" v-model="datoPlaDetObs.idRespuesta">
              <option disabled value="">Seleccione una respuesta...</option>
              <option v-for="respuesta in respuestas"
                :value="respuesta.idRespuesta" :key="respuesta.idRespuesta">
                {{ respuesta.descripcion }}
              </option>
            </select>
          </div>

          <!-- Respuesta complementaria + micrófono -->
          <div class="mb-3">
            <label for="respuesta" class="form-label fw-bold">
              Respuesta complementaria
            </label>
            <div class="d-flex gap-2 align-items-start">
              <textarea class="form-control" id="respuesta"
                v-model="datoPlaDetObs.respuesta"
                style="text-transform: uppercase;" rows="4">
              </textarea>
              <div class="d-flex flex-column align-items-center justify-content-center pt-1">
                <button
                  v-if="isDictatingCampo !== 'respuesta'"
                  @click="startDictation('respuesta')"
                  type="button"
                  class="btn btn-outline-danger"
                  title="Iniciar dictado"
                  style="width: 52px; height: 52px;"
                >
                  <span class="material-symbols-outlined" style="font-size: 28px;">
                    mic_off
                  </span>
                </button>
                <button v-else @click="stopDictation" type="button"
                  class="btn btn-outline-success" title="Finalizar dictado"
                  style="width: 52px; height: 52px;">
                  <span class="material-symbols-outlined" style="font-size: 28px;">
                    mic
                  </span>
                </button>
                <small class="text-muted mt-1" style="font-size: 0.7rem;">
                  {{ isDictatingCampo === 'respuesta' ? 'Grabando' : 'Dictado' }}
                </small>
              </div>
            </div>
          </div>

          <!-- Botón guardar -->
          <div class="d-flex justify-content-end border-top pt-3 mt-2">
            <button type="button" class="btn btn-primary"
              @click.prevent="guardarPlaDetObs" title="Guardar respuesta">
              <span class="material-symbols-outlined"
                style="font-size: 20px; vertical-align: middle;">
                save
              </span>
              Guardar
            </button>
          </div>

        </form>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import SpeechDictation from "@/modules/microfono.js";
import swal from "sweetalert";

export default {
  components: { Layout, Footer },
  data() {
    return {
      datoPlaDetObs: {},
      p_idPlaDetObs: this.$route.params.p_idpladetobs,
      p_observacionTipo: this.$route.params.p_observaciontipo,
      respuestas: [],
      planillaSeleccionada: null,
      dictation: new SpeechDictation(),
      isDictatingCampo: null,
      showModalHelp: false,
    };
  },
  created() {
    const planillaJSON = sessionStorage.getItem("planillaSeleccionada");
    if (planillaJSON) this.planillaSeleccionada = JSON.parse(planillaJSON);
  },
  mounted() {
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchRespuestas();
  },
  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },
    getData() {
      api.get("/vwpladetobss/" + this.p_idPlaDetObs)
        .then(response => { this.datoPlaDetObs = response.data; })
        .catch(error => console.error("Error al obtener datos:", error));
    },
    async guardarPlaDetObs() {
      if (!this.datoPlaDetObs.idRespuesta) {
        swal("Error!", "La respuesta estándar es obligatoria", "error");
        return;
      }
      if (this.datoPlaDetObs.idRespuesta || this.datoPlaDetObs.respuesta) {
        try {
          this.datoPlaDetObs.idUsuarioRes = window.sessionStorage.getItem("idUsuario");
          await api.post("/pladetobss", this.datoPlaDetObs);
          swal("Correcto!", "Respuesta registrada exitosamente!", "success");
          this.$router.push({
            path: `/planillas-observaciones/${this.planillaSeleccionada.idTramite}`,
          });
        } catch {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      } else {
        swal("Error!", "Ingrese una respuesta", "error");
      }
    },
async fetchRespuestas() {
  try {
    const r = await api.get("/vwrespuestas");
    this.respuestas = r.data;
  } catch (e) { console.error("Error al obtener respuestas:", e); }
},
    startDictation(campo) {
      this.isDictatingCampo = campo;
      const valorActual = this.datoPlaDetObs[campo] || '';
      this.dictation.startDictation(transcript => {
        this.datoPlaDetObs[campo] = transcript;
      }, valorActual);
    },
    stopDictation() {
      this.isDictatingCampo = null;
      this.dictation.stopDictation();
    },
  },
};
</script>